/**
 * 定义全局常量
 */
export const PREFIX_CLASS = '' // 样式全局前缀
export const PREFIX_ICON_CLASS = 'aid-' // 图标字体样式类前缀
export const CLASS_MAIN = 'aid' // 主样式类名
export const ICON_CLOSE = `${CLASS_MAIN} ${PREFIX_ICON_CLASS}close` // 关闭图标样式类名
export const SUCCESS = 'success'
export const INFO = 'info'
export const WARNING = 'warning'
export const DANGER = 'danger'



// WEBPACK FOOTER //
// ./src/utils/constants.js